module.exports = __webpack_public_path__ + "img/prosud.0068deeb.jpg";